import { Navigate, useRoutes, Outlet } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { PageCaySamNFC } from 'src/pages/caysam/details';
import HomeViewTraCuu from 'src/sections/home/home-view-tracuu';
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';
import { cameraRoutes } from './camera';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <MainLayout>
          <Outlet />
        </MainLayout>
      ),
      children: [{ element: <HomePage />, index: true }],
    },

    // Auth routes
    ...authRoutes,
    
    ...authDemoRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    ...cameraRoutes,
    
    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,
    // CaySam
    {path:'caysam',children:[
      {path:'me', element:  <MainLayout><HomeViewTraCuu/></MainLayout>},
      {path:':id', element: <PageCaySamNFC/>}
    ]},
   
    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
